import { deleteToken, getToken } from './cookies'
import axios from 'axios'

// Client Componentlerde kullanılırsa serverdamıyız diye kontrol etmemiz gerekir.
// şimdilik serverda kullanılacak

const apiUrl = "https://be.jodi.ac"

const axiosImage = axios.create({
    baseURL: apiUrl,
    headers: {
      'Content-Type': 'multipart/form-data',
      'Access-Control-Allow-Origin': '*'
    }
  })

  axiosImage.interceptors.request.use(async (config) => {
  let token = null

  token = await getToken('jodiactoken')

  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`
  }

  return config
})

axiosImage.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    if (error?.response?.status === 401) {
      deleteToken('jodiactoken')
      deleteToken('user')
    }
    if (error?.response?.status === 404) {
      return Promise.reject(error)
    }
    return Promise.reject(error)
  }
)

export default axiosImage


